import React from "react";
import styles from "./RadioWithInput.module.css";

function RadioWithInput({
  checked,
  inputPlaceholder,
  inputName,
  label,
  register,
  name,
  value,
  result,
}) {
  return (
    <div className={styles.radio_with_input}>
      <label htmlFor="">
        <input {...register(name)} type="radio" name={name} value={value} />
        {label}
      </label>
      {result === value && (
        <div className={styles.input}>
          <input
            placeholder={inputPlaceholder}
            name={inputName}
            {...register(inputName)}
            type="number"
          />
        </div>
      )}
    </div>
  );
}

export default RadioWithInput;
